module.exports = __webpack_public_path__ + "img/aimt.50ee5464.png";